import React from "react";
import Navbar from "../../components/navbar/Navbar";
import OrderInvoice from "../../components/invoices/OrderInvoice";

const OrderInvoicePage = () => {
  return (
    <>
      <section className="bajaj_main_block">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 p-0">
              <Navbar content="Report" />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 p-0">
              <OrderInvoice />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OrderInvoicePage;
